var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box-main" },
    [
      _c(
        "div",
        { staticClass: "main" },
        [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "main-center" },
            [
              _c(
                "v-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: "upgrade:policy:add",
                      expression: "'upgrade:policy:add'",
                    },
                  ],
                  staticClass: "v-icon-add mr10",
                  attrs: { type: "primary", name: "" },
                  on: {
                    click: function ($event) {
                      return _vm.showEdit()
                    },
                  },
                },
                [_vm._v("添加")]
              ),
              _c("v-input", {
                staticClass: "mr10",
                attrs: {
                  placeholder: "请输入搜索内容",
                  "suffix-icon": "v-icon-search",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
              _c(
                "v-button",
                {
                  staticClass: "ml10 mr10",
                  attrs: { type: "primary", name: "" },
                  on: { click: _vm.handleSearch },
                },
                [_vm._v("查询")]
              ),
              _c(
                "v-button",
                {
                  attrs: { type: "info", name: "" },
                  on: { click: _vm.handleClear },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "vxe-table",
                {
                  attrs: {
                    border: "",
                    "row-id": "id",
                    data: _vm.table,
                    align: "left",
                    "row-style": _vm.setRowClass,
                  },
                  on: { "cell-click": _vm.cellClickEvent },
                },
                [
                  _c("vxe-table-column", {
                    attrs: {
                      field: "strategy_id",
                      "show-overflow": "",
                      "min-width": "120",
                      title: "ID",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "strategy_typeshow",
                      "show-overflow": "",
                      "min-width": "160",
                      title: "策略类型",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "product_name",
                      "show-overflow": "",
                      "min-width": "160",
                      title: "产品名称",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "source_ver",
                      "show-overflow": "",
                      "min-width": "160",
                      title: "源版本",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "target_ver",
                      "show-overflow": "",
                      "min-width": "160",
                      title: "目标版本",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "upgrade_type",
                      "show-overflow": "",
                      "min-width": "160",
                      title: "升级时间",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (slotProps) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  slotProps.row.upgrade_type === 1
                                    ? "立即升级"
                                    : `${slotProps.row.start_time}-${slotProps.row.end_time}`
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "created_at",
                      "show-overflow": "",
                      "min-width": "160",
                      title: "上传时间",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: { title: "操作", "min-width": "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (slotProps) {
                          return [
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn4",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDetails(slotProps.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("查看")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn3",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDel(slotProps.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("删除")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.total
            ? _c("v-pagination", {
                attrs: {
                  total: _vm.total,
                  name: "page-basic",
                  "is-show-total": "",
                  "is-change-size": "",
                  "is-input-page": "",
                  "current-page": _vm.currentPage,
                },
                on: {
                  "change-page": _vm.changePage,
                  "change-size": _vm.changeSize,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("Edit", {
        ref: "Edit",
        attrs: { showInputDialog: _vm.showEditDialog, row: _vm.row },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.showEditDialog = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.showEditDialog = $event
          },
          getData: function ($event) {
            return _vm.getData()
          },
        },
      }),
      _c("Del", {
        ref: "Del",
        attrs: { showInputDialog: _vm.delLoading, row: _vm.row },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.delLoading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.delLoading = $event
          },
          getData: function ($event) {
            return _vm.getData()
          },
        },
      }),
      _c("Details", {
        ref: "Details",
        attrs: { showInputDialog: _vm.detailsLoading, row: _vm.row },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.detailsLoading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.detailsLoading = $event
          },
          getData: function ($event) {
            return _vm.getData()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "main-title" }, [_vm._v("强制配置")]),
      _c("div", { staticClass: "main-title-tips no-border" }, [
        _vm._v("可设定强制升级策略，强制升级策略需要设备端适配后才可生效"),
      ]),
      _c("div", { staticClass: "main-title-tips" }, [
        _vm._v("注：基于SN的升级策略的优先级高于基于产品名称"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }